import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

export default function Navbar() {
  const reduce = useReducedMotion();
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { href: "#home", label: "Home" },
    { href: "#services", label: "Services" },
    { href: "#pricing", label: "Rates" },
    { href: "#venture", label: "GurshaPlus" },
    { href: "#projects", label: "Projects" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-40 border-b-2 border-black/10 bg-white/90 backdrop-blur-md">
      <nav className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="#home" className="font-display text-xl font-semibold tracking-tight text-black">
            Natnael<span className="text-stone-500">.</span>
          </a>

          <div className="hidden sm:flex items-center gap-8 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-stone-600">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="hover:text-black transition-colors">
                {l.label}
              </a>
            ))}
            <a
              href={`${process.env.PUBLIC_URL}/resume.html`}
              target="_blank"
              rel="noreferrer"
              className="hover:text-black transition-colors"
            >
              Resume
            </a>
            <a
              href="#contact"
              className="inline-flex items-center border-2 border-black bg-black text-white px-4 py-2 font-semibold uppercase tracking-[0.15em] text-[10px] hover:bg-stone-800 transition-colors"
            >
              Let's talk
            </a>
          </div>

          <div className="flex sm:hidden items-center gap-3">
            <button
              type="button"
              aria-expanded={isOpen}
              aria-controls="primary-mobile-nav"
              aria-label={isOpen ? "Close menu" : "Open menu"}
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 border-2 border-transparent text-stone-700 hover:border-stone-300 transition-colors"
            >
              {isOpen ? <FiX size={22} /> : <FiMenu size={22} />}
            </button>
          </div>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              id="primary-mobile-nav"
              initial={reduce ? false : { opacity: 0, y: -10 }}
              animate={reduce ? false : { opacity: 1, y: 0 }}
              exit={reduce ? { opacity: 0, transition: { duration: 0 } } : { opacity: 0, y: -10 }}
              transition={{ duration: reduce ? 0 : 0.2 }}
              className="absolute left-0 right-0 top-full border-b-2 border-black/10 bg-white sm:hidden px-6 py-5"
            >
              <div className="flex flex-col gap-5">
                {links.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    onClick={() => setIsOpen(false)}
                    className="font-mono text-sm font-semibold uppercase tracking-[0.2em] text-stone-700 hover:text-black transition-colors"
                  >
                    {l.label}
                  </a>
                ))}
                <a
                  href={`${process.env.PUBLIC_URL}/resume.html`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => setIsOpen(false)}
                  className="font-mono text-sm font-semibold uppercase tracking-[0.2em] text-stone-700 hover:text-black transition-colors"
                >
                  Resume
                </a>
                <a
                  href="#contact"
                  onClick={() => setIsOpen(false)}
                  className="inline-flex items-center justify-center border-2 border-black bg-black text-white px-4 py-3 font-mono font-semibold uppercase tracking-[0.15em] text-xs hover:bg-stone-800 transition-colors"
                >
                  Let's talk
                </a>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
}
